'use strict';

if (!global.Zone) {
  throw new Error('zone.js should be installed before loading the long stack trace zone');
}

global.Zone.longStackTraceZone = require('../zones/long-stack-trace.js');



/*****************
 ** WEBPACK FOOTER
 ** ./~/zone.js/lib/browser/long-stack-trace-zone.js
 ** module id = 507
 ** module chunks = 1
 **/